'use client'
import { useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md'
import 'swiper/css';
import 'swiper/css/navigation';
import LinkComponent from '@components/LinkComponent';
import LargePropertyCard from '@components/LargePropertyCard';
// import { useTheme } from '@/context/ThemeContext'
// import dynamic from 'next/dynamic'


// Same chevron-in-a-circle nav treatment as AgentCardSlider — replaces
// Swiper's own default `navigation` buttons, which render as small,
// unstyled arrows that are easy to miss and don't match the rest of the site.
function NavButton({ innerRef, direction, disabled }) {
  const isPrev = direction === 'prev'
  return (
    <button
      ref={innerRef}
      type="button"
      aria-label={isPrev ? 'Previous' : 'Next'}
      disabled={disabled}
      className={`absolute top-1/2 -translate-y-1/2 z-10 bg-black/50 hover:bg-black/80 text-white rounded-full p-1.5 disabled:opacity-0 disabled:pointer-events-none transition-all ${isPrev ? 'left-2' : 'right-2'}`}
    >
      {isPrev ? <MdChevronLeft size={22} /> : <MdChevronRight size={22} />}
    </button>
  )
}

// inside PropertyCardSlider


const PropertyCardSlider = ({
  title, description, propertySlider, properties, url, cardType, cardStyle, dictionary, lang,
  slidesPerView = 4, slidesPerViewMobile = 1.5,
  // NEW — previously PropertyCardSlider only ever rendered title/description
  // through the fixed carousel-title-align / carousel-description-align CSS
  // classes, so there was no way to override size/weight/align/color per
  // section (same gap AgentCarousel had before it got these props threaded
  // through its wrapper).
  titleColor, titleSize, titleWeight, titleAlign, subtitleColor, subtitleSize,
  // NEW — section background: bgType 'solid' | 'gradient' | 'image', with an
  // optional overlay on top of an image. Same shape/field names as
  // content_blocks and agent_carousel so a shared bg-picker can drop in later.
  bgType, bgColor, bgGradient, bgImageUrl, overlayColor, overlayOpacity,
}) => {
      const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // console.log('propertySlider')
  // console.log(propertySlider)
    // const { propertySlider } = useTheme()

    // const CardComponent = cardComponents[propertySlider?.cardStyle || 'default']

  // No title text (e.g. the home page draws the section header itself) → no empty <h2>
  const hasTitle = !!title?.[lang]?.trim()

  const prevRef = useRef(null)
  const nextRef = useRef(null)
  const [isBeginning, setIsBeginning] = useState(true)
  const [isEnd, setIsEnd] = useState(false)

  // These layer on top of the existing CSS classes (color/size/weight/align
  // only), so sections that never set them fall through to the class's own
  // defaults via `undefined`.
  const titleStyle = {
    color:      titleColor  || undefined,
    fontSize:   titleSize   || undefined,
    fontWeight: titleWeight || undefined,
    textAlign:  titleAlign  || undefined,
  }
  const descStyle = {
    color:    subtitleColor || undefined,
    fontSize: subtitleSize  || undefined,
  }

  // Old saved sections without bgType fall back to 'solid' + '#ffffff' (fully
  // transparent-looking, matches the section's previous unstyled background).
  const resolvedBg = bgType === 'gradient' ? (bgGradient || undefined)
    : bgType === 'image' && bgImageUrl
      ? `url(${bgImageUrl}) center/cover no-repeat`
      : (bgColor || undefined)
  const showOverlay = bgType === 'image' && bgImageUrl && overlayOpacity > 0
  const overlayEl = showOverlay ? (
    <div style={{
      position: 'absolute', inset: 0, pointerEvents: 'none',
      background: overlayColor || '#000000', opacity: overlayOpacity,
    }} />
  ) : null

if (!mounted) {
  const maxSlides =
    propertySlider?.propertySlider?.desktop ||
    propertySlider?.propertySlider?.tablet ||
    Math.ceil(propertySlider?.propertySlider?.mobile || 1.2) ||
    4

  const limitedProperties = properties.slice(0, maxSlides)

  return (
    <section className='carousel-wrapper lg:pl-0 pl-3' style={{ position: 'relative', background: resolvedBg }}>
      {overlayEl}
      <div style={{ position: 'relative' }}>
        {hasTitle && (url ? (
          <LinkComponent href={`/${url}`}>
            <h2 className='carousel-title-align' style={titleStyle}>
              {title[lang]}
            </h2>
          </LinkComponent>
        ) : (
          <h2 className='carousel-title-align' style={titleStyle}>
            {title[lang]}
          </h2>
        ))}
        {description?.[lang]?.trim() && (
            <p className='carousel-description-align' style={descStyle}>
            {description[lang]}
            </p>
        )}
        <div 
        className="flex flex-row"
        style={{
          gap: '16px'
        }}
        >
          {limitedProperties.map((property, index) => (
            <LargePropertyCard
              key={index}
              property={property}
              dictionary={dictionary.card}
              cardType={cardType}
              lang={lang}
              cardStyle={cardStyle}
            />
          ))}
        </div>
      </div>
    </section>
  )
}


 return (
    <section className='carousel-wrapper w-full lg:pl-0 pl-3 ' style={{ position: 'relative', background: resolvedBg }}>
      {overlayEl}
      <div style={{ position: 'relative' }}>
      {hasTitle && (url ? (
        <LinkComponent href={`/${url}`}>
          <h2 className='carousel-title-align' style={titleStyle}>
            {title[lang]}
          </h2>
        </LinkComponent>
      ) : (
        <h2 className='carousel-title-align' style={titleStyle}>
          {title[lang]}
        </h2>
      ))}

        {description?.[lang]?.trim() && (
            <p className='carousel-description-align' style={descStyle}>
            {description[lang]}
            </p>
        )}
        <div className="relative">
          <Swiper
              spaceBetween={16}
              modules={[Navigation]}
              slidesPerView={propertySlider?.propertySlider?.mobile || 1.2}
              breakpoints={{
                  768: {
                  slidesPerView: propertySlider?.propertySlider?.tablet || 3,
                  },
                  1024: {
                  slidesPerView: propertySlider?.propertySlider?.desktop || 4,
                  },
              }}
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current
                swiper.params.navigation.nextEl = nextRef.current
              }}
              navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
              onSlideChange={(swiper) => {
                setIsBeginning(swiper.isBeginning)
                setIsEnd(swiper.isEnd)
              }}
              onSwiper={(swiper) => {
                setIsBeginning(swiper.isBeginning)
                setIsEnd(swiper.isEnd)
              }}
          >
          {properties.map((property, index) => (
              <SwiperSlide key={index}>
                  <LargePropertyCard
                      property={property}
                      dictionary={dictionary.card}
                      cardType={cardType}
                      lang={lang}
                      cardStyle={cardStyle}
                  />
              </SwiperSlide>
          ))}
          </Swiper>
          <NavButton innerRef={prevRef} direction="prev" disabled={isBeginning} />
          <NavButton innerRef={nextRef} direction="next" disabled={isEnd} />
        </div>
      </div>
    </section>
  )
};

export default PropertyCardSlider;